var validationUtils = require('./validation-utils');
var usePOST = true;


/**
 * Verify an email address
 * @param  {String}     value
 * @return {Object}     data
 * @return {Boolean}    data.isValid
 * @return {Object}     data.options
 */
function _verifyEmailAddress(value) {
    var url = '/api/inventory/userinfoValidation/validateEmail';
    var parameters = {emailId: value};
    return validationUtils.reliableRequest(url, parameters, usePOST).then(function(data) {
        var isValid = !!(data.result.match(/^(verified|unknown)$/i));

        return {
            isValid: isValid,
            options: data
        };
    });
}

/**
 * Verify a phone number type
 * @param  {String}     value
 * @param  {Array}      types
 * @return {Object}     data
 * @return {Boolean}    data.isValid
 * @return {Object}     data.options
 */
function _verifyPhoneNumberType(value, types) {
    var url = '/api/inventory/userinfoValidation/validatePhoneNumber';
    var parameters = {number: value};

    return validationUtils.reliableRequest(url, parameters, usePOST).then(function(data) {
        var pattern = new RegExp('^(' + types.join('|') + ')$', 'i');
        var isValid = !!(data.phoneType.match(pattern));

        return {
            isValid: isValid,
            options: data
        };
    });
}

function _verifyZipCode(value) {
    var url = '/api/region/zip/validation/' + value;
    var parameters = { format: 'json' };

    return validationUtils.reliableRequest(url, parameters).then(function(data) {
        return {
            isValid: data[value] === 'true',
            options: data
        };
    });
}

function _verifyPhoneNumber(value) {
    return _verifyPhoneNumberType(value, ['LandLine', 'Mobile']);
}

function _verifyMobileNumber(value) {
    return _verifyPhoneNumberType(value, ['Mobile']);
}

function _verifyLandLineNumber(value) {
    return _verifyPhoneNumberType(value, ['LandLine']);
}

/**

 Example:

 var verificator = require('src/interlock/no-ui/validation/common/verification');

 verificator.verifyEmail('test@edmunds.com').then(function(data) {
    var isValid = data.isValid;
    var options = data.options;
});

 */

module.exports = {
    verifyEmail: _verifyEmailAddress,
    verifyLandLineNumber: _verifyLandLineNumber,
    verifyMobileNumber: _verifyMobileNumber,
    verifyPhoneNumber: _verifyPhoneNumber,
    verifyZipCode: _verifyZipCode
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/validation/common/verification.js
// module id = 30
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 16 19 21 24 25